import SelectComponent from "../../../ui/select/SelectComponent";
import Role from "../../../../model/user/Role";

export default class SelectRoles extends SelectComponent<Role> {
	matchFilter(element: Role, filter: string): boolean {
		return element.label.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: Role): string {
		return element.id;
	}

	elementToString(element: Role) {
		return element.value;
	}

	onInputChange(value: string) {
		this.props.onInputChange(value);
	}
}